import SetActive from './setActive';

const accordion = new SetActive('.single-product-acc-heading', true);

export default accordion;


